// Profile Page
export default function Profile() { return <div><h1 className="text-3xl font-bold">My Profile</h1><p className="mt-4">Manage your account details.</p></div>; }